import type { SisFieldKey } from './sisFieldMapping';

// The single source of truth for how roster columns are named to the user. The
// upload guidance panel, the data help panel, and the column-mapping step all
// read from here so the same column can't be renamed as someone moves between
// consecutive onboarding steps.
export const ROSTER_FIELD_LABELS: Record<SisFieldKey, string> = {
  student_id: 'District Student ID',
  state_student_id: 'State Student ID',
  el_service_start: 'EL service start date (or years in EL)',
  exit_date: 'Exit date',
  exit_reason: 'Exit reason',
  school: 'School',
  grade: 'Grade',
  el_status: 'EL status',
  program_model: 'Program model',
  dually_identified: 'Dually-identified',
  iep: 'IEP',
  section_504: 'Section 504',
  originating_district: 'Originating district',
  alternate_access: 'Alternate ACCESS',
  newcomer_flag: 'Newcomer flag',
  home_language: 'Home language',
  assigned_teacher: 'EL Teacher',
  pronouns: 'Pronouns',
};

export const MUST_INCLUDE_HEADING = 'Must include';
export const HELPFUL_HEADING = 'Helpful to include';

export const ROSTER_MUST_INCLUDE_KEYS: ReadonlyArray<SisFieldKey> = [
  'student_id',
  'el_service_start',
  'exit_date',
  'exit_reason',
  'school',
];

export const ROSTER_HELPFUL_KEYS: ReadonlyArray<SisFieldKey> = [
  'state_student_id',
  'grade',
  'assigned_teacher',
  'el_status',
  'program_model',
  'dually_identified',
  'newcomer_flag',
];

export function rosterFieldLabels(keys: ReadonlyArray<SisFieldKey>): string[] {
  return keys.map((key) => ROSTER_FIELD_LABELS[key]);
}
